module.exports = __webpack_public_path__ + "media/images/emblems/Erlenbach_im_Simmental-coat_of_arms-313df7c3217ecbd2e9a16afec08ccc50.svg";